import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Tabs } from 'antd';

// Internal Imports
import EditTextForm from "../../common/components/EditTextForm/EditTextForm";
import MarginInput from "../../common/components/MarginInput/MarginInput";
import ModalContainer from "../../common/components/ModalContainer/ModalContainer";
import Paint from "../../common/components/Paint/Paint";
import SelectBox from "../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../common/constants/colors";
import { getError, openNotification, tryCatch } from "../../common/constants/Utilities";
import GroupRow from "../../common/components/GroupRow/GroupRow";
import { IDepartment } from "../../interfaces/IDepartment";
import { IUserGroup, IUserGroupDetail, IUserInformation } from "../../interfaces/IUser";
import { InsertUserGroup, UpdateUserGroup } from "../../services/userGroup";
import globalStyle from '../../common/styles/globalStyle.module.css';
import LoadingButton from "../../common/components/LoadingButton/LoadingButton";
import IColumn from "../../interfaces/IColumn";
import ButtonGrid from "../../common/components/ButtonGrid/ButtonGrid";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import DetailTable from "../../common/components/DetailTable/DetailTable";
import SearchText from "../../common/components/SearchText/SearchText";
import ModalBtnCotainer from "../../common/components/ModalBtnContainer/ModalBtnContainer";
import { Mode } from "../../common/types/AllTypes";
import Modal from "../../common/components/Modal/Modal";
import { LoadingIcon } from "../../common/constants/cssElements";



interface Props {
    userGroupUpdate?: IUserGroup;
    mode: Mode;
    setUserGroupUpdate: any;
    setAddUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
    listDepartment: IDepartment[];
    loadingDeparment: boolean;
    users: IUserInformation[];
    loadingUser: boolean;
    setDataList: (list: IUserGroup[]) => void;
    dataList: IUserGroup[]
}

// Options Tabs
const { TabPane } = Tabs;

const AddUpdateUserGroup = ({ dataList, setDataList, userGroupUpdate, mode, setUserGroupUpdate, setAddUpdateModal, listDepartment, loadingDeparment, users, loadingUser }: Props) => {

    // States
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const [listUserInformation, setListUserInformation] = useState<IUserInformation[]>([]);
    const [filtro, setFiltro] = useState<string>('');
    const [searchAdd, setSearchAdd] = useState<string>('');
    const [searchUpd, setSearchUpd] = useState<string>('');

    const [userGroupDetail, setUserGroupDetail] = useState<IUserGroupDetail[]>([]);
    const [userGroupDetailMain, setUserGroupDetailMain] = useState<IUserGroupDetail[]>([]);

    // Const
    const filtrarOptions: any[] = [
        { key: 'fo0', value: 'nombreUsuario', text: 'Usuario' },
        { key: 'fo1', value: 'primerNombre', text: 'Nombre' },
        { key: 'fo2', value: 'primerApellido', text: 'Apellido' },
        { key: 'fo3', value: 'correo', text: 'Correo' },
        { key: 'fo5', value: 'puestoNombre', text: 'Puesto' }
    ];

    const columns = (columnMode: Mode) => {
        const rows: IColumn[] = [
            {
                title: 'Usuario',
                dataIndex: '',
                render: (data: IUserInformation) => data.nombreUsuario
            },
            {
                title: 'Nombre',
                dataIndex: 'primerNombre',
            },
            {
                title: 'Apellido',
                dataIndex: 'primerApellido',
            },
            {
                title: 'Correo',
                dataIndex: 'correo',
            },
            {
                title: 'Puesto',
                dataIndex: '',
                render: (data: IUserInformation) => data.usuarioProyecto?.puestoNombre
            },

            {
                title: columnMode === 'Add'
                    ? <ButtonGrid color={COLORS.blue_active} active={!formLoading} icon={<PlusOutlined />} background={COLORS.white_color1} method={() => addAll()} />
                    : <ButtonGrid color={COLORS.red_error2} active={!formLoading} icon={<DeleteOutlined />} background={COLORS.white_color1} method={() => deleteAll()} />,
                dataIndex: '',
                render: (detail: IUserInformation) => (
                    <ButtonGrid color={COLORS.black_text_color4} active={!formLoading} icon={columnMode === 'Add' ? <PlusOutlined /> : <DeleteOutlined />} method={() => columnMode === 'Add' ? addUserDetail(detail) : deleteUserDetail(detail)} />
                )
            }
        ]
        return rows;
    }

    // Methods
    const validations = (values: any) => {
        const errors: any = {};
        if (!values.nombre) {
            errors.nombre = 'Requerido';
        }

        if (!values.departamentoGUID) {
            errors.departamentoGUID = 'Requerido';
        }
        return errors;
    };

    const searchUser = (filtro: string, value: string, modeSearch: Mode) => {
        if (modeSearch === 'Add') {
            setSearchAdd(value);
            if (!!value) {
                if (filtro === 'puestoNombre') {
                    setListUserInformation(users.filter(x => !userGroupDetail.map(us => us.userInfo!).includes(x)).filter((user: any) => user.usuarioProyecto[filtro].toLowerCase().includes(value.toLowerCase())));
                }
                else {
                    setListUserInformation(users.filter(x => !userGroupDetail.map(us => us.userInfo!).includes(x)).filter((user: any) => user[filtro].toLowerCase().includes(value.toLowerCase())));
                }                
            } else {
                setListUserInformation(users.filter(x => !userGroupDetail.map(us => us.userInfo!).includes(x)));
            }
        } else {
            setSearchUpd(value);
            if (!!value) {
                if (filtro === 'puestoNombre') {
                    setUserGroupDetail(userGroupDetailMain?.filter((user: any) => user.userInfo.usuarioProyecto[filtro].toLowerCase().includes(value.toLowerCase())));
                }
                else {
                    setUserGroupDetail(userGroupDetailMain?.filter((user: any) => user.userInfo[filtro].toLowerCase().includes(value.toLowerCase())));
                }                 
            } else {
                setUserGroupDetail(userGroupDetailMain);
            }
        }
    }

    const searchUserTipo = (value: string, modeSearch: Mode) => {
        setFiltro(value);
        if (modeSearch === 'Add') {
            searchUser(value, searchAdd, modeSearch)
        } else { 
            searchUser(value, searchUpd, modeSearch)
        }        
    }

    const addUserDetail = (user: IUserInformation) => {
        let list = userGroupDetailMain;
        list?.push({ grupoUsuarioDetalleID: 0, grupoUsuarioID: mode === 'Add' ? 0 : userGroupUpdate?.grupoUsuarioID, usuarioGUID: user.usuarioGUID, userInfo: user });
        setUserGroupDetail([...list]);
        setUserGroupDetailMain([...list]);
    }

    const addAll = () => {
        let list = userGroupDetailMain;
        listUserInformation.filter(x => !userGroupDetail.map(us => us.userInfo!).includes(x)).forEach(user => {
            if (!userGroupDetailMain.some(us => us.usuarioGUID === user.usuarioGUID)) {
                list?.push({ grupoUsuarioDetalleID: 0, grupoUsuarioID: mode === 'Add' ? 0 : userGroupUpdate?.grupoUsuarioID, usuarioGUID: user.usuarioGUID, userInfo: user });
            }
        });
        setUserGroupDetail([...list]);
        setUserGroupDetailMain([...list]);
    }

    const deleteAll = () => {
        let list = userGroupDetailMain.filter(x => !userGroupDetail.includes(x));
        setUserGroupDetail([...list]);
        setUserGroupDetailMain([...list]);
        setSearchUpd('');
    }

    const deleteUserDetail = (user: IUserInformation) => {
        let list = userGroupDetailMain.filter(det => det.usuarioGUID !== user.usuarioGUID);
        setUserGroupDetail([...list]);
        setUserGroupDetailMain([...list]);
        setSearchUpd('');
    }

    // Handles
    const handleUserGroup = (values: any) => {
        setFormLoading(true);
        const newUserGroup: IUserGroup = {
            grupoUsuarioID: 0,
            nombre: values.nombre,
            departamentoGUID: values.departamentoGUID,
            grupoUsuarioDetalle: userGroupDetailMain
        }
        tryCatch(() => {
            if (mode === 'Add') {
                InsertUserGroup(newUserGroup)
                    .then((response) => {
                        openNotification('success', `Grupo de Usuarios agregado`, response.msg!);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IUserGroup = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;

                        let dataListInternal = dataList;
                        dataListInternal.push(result);
                        setDataList([...dataListInternal]);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setFormLoading(false));
            } else {
                newUserGroup.grupoUsuarioID = userGroupUpdate!.grupoUsuarioID;
                UpdateUserGroup(newUserGroup)
                    .then((response) => {
                        openNotification('success', `Grupo de Usuarios Modificado`, response.msg!);
                        setUserGroupUpdate(response.data);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IUserGroup = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;
                        let userG = dataList.findIndex(x => x.grupoUsuarioID === userGroupUpdate?.grupoUsuarioID);

                        let dataListInternal = dataList;
                        dataListInternal[userG] = result;
                        setDataList([...dataListInternal]);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setFormLoading(false));
            }
        })
    }

    // Form
    const UserGroupForm = useFormik({
        initialValues: { nombre: '', departamentoGUID: '' },
        validate: validations,
        onSubmit: (values: any) => handleUserGroup(values)
    });

    // Components
    const UserDetail = (listUser: IUserInformation[], modeDetail: Mode) => (
        <div className="useG_UserDetail">
            <GroupRow>
                <MarginInput width="20%">
                    <SelectBox
                        value={filtro}
                        placeholder={"Filtrar por"}
                        defaultValue={filtro}
                        disabled={false}
                        allowClear={false}
                        loading={false}
                        onChange={(value: string) => searchUserTipo(value, modeDetail)}
                        options={filtrarOptions}
                        backgroundColor={COLORS.transparent_color1}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                </MarginInput>

                <MarginInput width="78%">
                    <SearchText
                        value={modeDetail === 'Add' ? searchAdd : searchUpd}
                        active={!!filtro}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        placeholdercolor={COLORS.black_text_color4}
                        name={"search"}
                        onChange={(value: string) => searchUser(filtro, value, modeDetail)}
                        placeholder={"Buscar"}
                        backgroundcolor={!!filtro ? COLORS.white_color2(1) : COLORS.black_back_color5}
                        opacity={1}
                        props={{ collapsed: 'false' }}
                    />
                </MarginInput>
            </GroupRow>
            <DetailTable
                props={{ rowKey: (record: any) => record.usuarioGUID }}
                dataSource={listUser}
                columns={columns(modeDetail)}
                loading={loadingUser}
            />
        </div>
    );


    useEffect(() => {
        setListUserInformation(users);
    }, [users]);

    useEffect(() => {
        if (mode === 'Update') {
            // EditText
            UserGroupForm.setValues({
                nombre: userGroupUpdate!.nombre,
                departamentoGUID: userGroupUpdate!.departamentoGUID!
            });

            // Detail
            let updateDetail = userGroupUpdate?.grupoUsuarioDetalle;
            updateDetail?.forEach(upD => upD.userInfo = users.find(us => us.usuarioGUID === upD.usuarioGUID));

            setUserGroupDetail(updateDetail!.filter(x => !!x.userInfo));
            setUserGroupDetailMain(updateDetail!.filter(x => !!x.userInfo));
        }
    }, []);

    return (
        <ModalContainer>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Nombre:</label>
                    <EditTextForm
                        value={UserGroupForm.values.nombre}
                        onChange={UserGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"nombre"}
                        placeholder={"Nombre"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserGroupForm.errors.nombre && UserGroupForm.errors.nombre}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Departamento:</label>
                    <SelectBox
                        value={UserGroupForm.values.departamentoGUID}
                        defaultValue={mode === 'Update' ? userGroupUpdate!.departamentoGUID : null}
                        placeholder={"Departamento"}
                        disabled={mode === 'Update' ? true : false}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => UserGroupForm.setFieldValue('departamentoGUID', value)}
                        options={listDepartment.map(dep => ({ key: dep.departamentoGUID, value: dep.departamentoGUID, text: dep.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        height={'40px'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserGroupForm.errors.departamentoGUID && UserGroupForm.errors.departamentoGUID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <div className="useG_Detail">
                <Tabs tabPosition={'top'}>
                    <TabPane tab="Usuarios" key="1">
                        {UserDetail(!!UserGroupForm.values.departamentoGUID ? (listUserInformation.filter(x => !userGroupDetail.map(us => us.userInfo!).includes(x) && x.usuarioProyecto!.departamentoGUID === UserGroupForm.values.departamentoGUID)) : [], 'Add')}
                    </TabPane>
                    <TabPane tab="Añadidos" key="2">
                        {UserDetail(userGroupDetail.map(us => us.userInfo!), 'Update')}
                    </TabPane>
                </Tabs>
            </div>

            <ModalBtnCotainer>
                <LoadingButton
                    type="button"
                    method={UserGroupForm.handleSubmit}
                    title={mode === 'Add' ? "Guardar" : 'Modificar'}
                    loading={formLoading.toString()}
                    background={COLORS.blue_active}
                    color={COLORS.white_color1}
                    style={{ padding: '3px', width: '200px', margin: 'auto', height: '32px' }}
                    fontsize={16}
                />
            </ModalBtnCotainer>


            <Modal props={{ style: { top: '-45px' } }} closable={false} width={"30%"} title={"Cargando..."} visible={formLoading} setVisible={setFormLoading} askBeforeClose={false}>
                <div className="stepThree_loading">
                    <LoadingIcon color={COLORS.blue_main(1)} size={'3em'} />
                </div>
            </Modal>
        </ModalContainer>

    );
}


export default AddUpdateUserGroup;